import React, { useContext } from 'react';

export class HttpStatusState {
  public status: number;

  public constructor(initialStatus: number) {
    this.status = initialStatus;
  }
}

const HttpStatusContext = React.createContext<HttpStatusState | undefined>(undefined);
export const ProvideHttpStatusState = HttpStatusContext.Provider;

export function useSetHttpStatus(status: number) {
  const httpStatusState = useContext(HttpStatusContext);

  if (httpStatusState) {
    // We mutate the state in the render method itself instead of using
    // useEffect because this is intended for server rendering, where useEffect
    // callbacks will not be called.
    httpStatusState.status = status;
  }
}
